import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { fg } from '@atlaskit/platform-feature-flags';
import { isContainedWithinMediaWrapper } from '../../vc-observer/media-wrapper/vc-utils';
import isDnDStyleMutation from '../../vc-observer/observers/non-visual-styles/is-dnd-style-mutation';
import isNonVisualStyleMutation from '../../vc-observer/observers/non-visual-styles/is-non-visual-style-mutation';
import { RLLPlaceholderHandlers } from '../../vc-observer/observers/rll-placeholders';
import { createIntersectionObserver } from './intersection-observer';
import createMutationObserver from './mutation-observer';
import createPerformanceObserver from './performance-observer';
import checkWithinComponent, { cleanupCaches } from './utils/check-within-component';
import { getMutatedElements } from './utils/get-mutated-elements';
import { isElementVisible } from './utils/is-element-visible';
import isInVCIgnoreIfNoLayoutShiftMarker from './utils/is-in-vc-ignore-if-no-layout-shift-marker';
import { isSameRectDimensions } from './utils/is-same-rect-dimensions';
import { isSameRectSize } from './utils/is-same-rect-size';
var createElementMutationsWatcher = function createElementMutationsWatcher(removedNodeRects) {
  return function (_ref) {
    var target = _ref.target,
      rect = _ref.rect;
    var isInIgnoreLsMarker = isInVCIgnoreIfNoLayoutShiftMarker(target);
    if (!isInIgnoreLsMarker) {
      return 'mutation:element';
    }
    var isRLLPlaceholder = RLLPlaceholderHandlers.getInstance().isRLLPlaceholderHydration(rect);
    if (isRLLPlaceholder && isInIgnoreLsMarker) {
      return 'mutation:rll-placeholder';
    }
    var wasDeleted = removedNodeRects.some(function (nr) {
      return isSameRectDimensions(nr, rect);
    });
    if (wasDeleted && isInIgnoreLsMarker) {
      return 'mutation:element-replacement';
    }
    return 'mutation:element';
  };
};
var ViewportObserver = /*#__PURE__*/function () {
  // SSR context functions

  function ViewportObserver(_ref2) {
    var _this = this;
    var onChange = _ref2.onChange,
      getSSRState = _ref2.getSSRState,
      getSSRPlaceholderHandler = _ref2.getSSRPlaceholderHandler;
    _classCallCheck(this, ViewportObserver);
    _defineProperty(this, "handleIntersectionEntry", function (_ref3) {
      var target = _ref3.target,
        rect = _ref3.rect,
        time = _ref3.time,
        type = _ref3.type,
        mutationData = _ref3.mutationData;
      if (!target) {
        return;
      }
      var visible = isElementVisible(target);
      var lastElementRect = _this.mapVisibleNodeRects.get(target);
      _this.mapVisibleNodeRects.set(target, rect);
      _this.onChange({
        time: time,
        type: type,
        elementRef: new WeakRef(target),
        visible: visible,
        rect: rect,
        previousRect: lastElementRect,
        mutationData: mutationData
      });
    });
    _defineProperty(this, "handleChildListMutation", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref4) {
        var target, addedNodes, removedNodes, timestamp, removedNodeRects, targetNode, _iterator, _step, _loop, _ret;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              target = _ref4.target, addedNodes = _ref4.addedNodes, removedNodes = _ref4.removedNodes, timestamp = _ref4.timestamp;
              removedNodeRects = removedNodes.map(function (ref) {
                var n = ref.deref();
                if (!n) {
                  return;
                }
                return _this.mapVisibleNodeRects.get(n);
              });
              targetNode = target.deref();
              _iterator = _createForOfIteratorHelper(addedNodes);
              _context2.prev = 4;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var addedNodeRef, addedNode, ssrState, SSRStateEnum, _this$intersectionObs, _this$intersectionObs2, ssrPlaceholderHandler, _this$intersectionObs3, result, _this$intersectionObs4, sameDeletedNode, isInIgnoreLsMarker, _this$intersectionObs5, _this$intersectionObs6, _checkWithinComponent, isWithinThirdPartySegment, _this$intersectionObs7, _iterator2, _step2, _step2$value, isDisplayContentsElementChildren, element, _this$intersectionObs8, _this$intersectionObs9;
                return _regeneratorRuntime.wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      addedNodeRef = _step.value;
                      addedNode = addedNodeRef.deref();
                      if (addedNode) {
                        _context.next = 4;
                        break;
                      }
                      return _context.abrupt("return", 0);
                    case 4:
                      if (!_this.getSSRState) {
                        _context.next = 19;
                        break;
                      }
                      ssrState = _this.getSSRState();
                      SSRStateEnum = {
                        normal: 1,
                        waitingForFirstRender: 2,
                        ignoring: 3
                      };
                      if (!(ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement)) {
                        _context.next = 12;
                        break;
                      }
                      ssrState.state = SSRStateEnum.ignoring;
                      if (ssrState.renderStop === -1) {
                        // arbitrary 500ms DOM update window
                        ssrState.renderStop = timestamp + 500;
                      }
                      (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, 'ssr-hydration');
                      return _context.abrupt("return", 0);
                    case 12:
                      if (!(ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && targetNode === ssrState.reactRootElement)) {
                        _context.next = 19;
                        break;
                      }
                      if (!(timestamp <= ssrState.renderStop)) {
                        _context.next = 18;
                        break;
                      }
                      (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(addedNode, 'ssr-hydration');
                      return _context.abrupt("return", 0);
                    case 18:
                      ssrState.state = SSRStateEnum.normal;
                    case 19:
                      if (!_this.getSSRPlaceholderHandler) {
                        _context.next = 33;
                        break;
                      }
                      ssrPlaceholderHandler = _this.getSSRPlaceholderHandler();
                      if (!ssrPlaceholderHandler) {
                        _context.next = 33;
                        break;
                      }
                      if (!(ssrPlaceholderHandler.isPlaceholder(addedNode) || ssrPlaceholderHandler.isPlaceholderIgnored(addedNode))) {
                        _context.next = 26;
                        break;
                      }
                      if (!ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(addedNode)) {
                        _context.next = 26;
                        break;
                      }
                      (_this$intersectionObs3 = _this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.watchAndTag(addedNode, 'mutation:ssr-placeholder');
                      return _context.abrupt("return", 0);
                    case 26:
                      if (!(ssrPlaceholderHandler.isPlaceholderReplacement(addedNode) || ssrPlaceholderHandler.isPlaceholderIgnored(addedNode))) {
                        _context.next = 33;
                        break;
                      }
                      _context.next = 29;
                      return ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(addedNode);
                    case 29:
                      result = _context.sent;
                      if (!(result !== false)) {
                        _context.next = 33;
                        break;
                      }
                      (_this$intersectionObs4 = _this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.watchAndTag(addedNode, 'mutation:ssr-placeholder');
                      return _context.abrupt("return", 0);
                    case 33:
                      sameDeletedNode = removedNodes.find(function (ref) {
                        var n = ref.deref();
                        if (!n || !addedNode) {
                          return false;
                        }
                        return n.isEqualNode(addedNode);
                      });
                      isInIgnoreLsMarker = isInVCIgnoreIfNoLayoutShiftMarker(addedNode);
                      if (!(sameDeletedNode && isInIgnoreLsMarker)) {
                        _context.next = 38;
                        break;
                      }
                      (_this$intersectionObs5 = _this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.watchAndTag(addedNode, 'mutation:remount');
                      return _context.abrupt("return", 0);
                    case 38:
                      if (!isContainedWithinMediaWrapper(addedNode)) {
                        _context.next = 41;
                        break;
                      }
                      (_this$intersectionObs6 = _this.intersectionObserver) === null || _this$intersectionObs6 === void 0 || _this$intersectionObs6.watchAndTag(addedNode, 'mutation:media');
                      return _context.abrupt("return", 0);
                    case 41:
                      _checkWithinComponent = checkWithinComponent(addedNode, 'UFOThirdPartySegment', _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                      if (!isWithinThirdPartySegment) {
                        _context.next = 45;
                        break;
                      }
                      (_this$intersectionObs7 = _this.intersectionObserver) === null || _this$intersectionObs7 === void 0 || _this$intersectionObs7.watchAndTag(addedNode, 'mutation:third-party-element');
                      return _context.abrupt("return", 0);
                    case 45:
                      _iterator2 = _createForOfIteratorHelper(getMutatedElements(addedNode));
                      try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          _step2$value = _step2.value, isDisplayContentsElementChildren = _step2$value.isDisplayContentsElementChildren, element = _step2$value.element;
                          if (isDisplayContentsElementChildren) {
                            (_this$intersectionObs8 = _this.intersectionObserver) === null || _this$intersectionObs8 === void 0 || _this$intersectionObs8.watchAndTag(element, 'mutation:display-contents-children-element');
                          } else {
                            (_this$intersectionObs9 = _this.intersectionObserver) === null || _this$intersectionObs9 === void 0 || _this$intersectionObs9.watchAndTag(element, createElementMutationsWatcher(removedNodeRects));
                          }
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }
                    case 47:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 7:
              if ((_step = _iterator.n()).done) {
                _context2.next = 14;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 9);
            case 9:
              _ret = _context2.t0;
              if (!(_ret === 0)) {
                _context2.next = 12;
                break;
              }
              return _context2.abrupt("continue", 12);
            case 12:
              _context2.next = 7;
              break;
            case 14:
              _context2.next = 19;
              break;
            case 16:
              _context2.prev = 16;
              _context2.t1 = _context2["catch"](4);
              _iterator.e(_context2.t1);
            case 19:
              _context2.prev = 19;
              _iterator.f();
              return _context2.finish(19);
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee, null, [[4, 16, 19, 22]]);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(this, "handleAttributeMutation", function (_ref6) {
      var _this$intersectionObs0;
      var target = _ref6.target,
        attributeName = _ref6.attributeName,
        oldValue = _ref6.oldValue,
        newValue = _ref6.newValue;
      (_this$intersectionObs0 = _this.intersectionObserver) === null || _this$intersectionObs0 === void 0 || _this$intersectionObs0.watchAndTag(target, function (_ref7) {
        var target = _ref7.target,
          rect = _ref7.rect;
        if (isContainedWithinMediaWrapper(target)) {
          return {
            type: 'mutation:media',
            mutationData: {
              attributeName: attributeName,
              oldValue: oldValue,
              newValue: newValue
            }
          };
        }
        if (isDnDStyleMutation({
          target: target,
          attributeName: attributeName,
          oldValue: oldValue,
          newValue: newValue
        })) {
          return {
            type: 'mutation:attribute:non-visual-style',
            mutationData: {
              attributeName: attributeName,
              oldValue: oldValue,
              newValue: newValue
            }
          };
        }
        if (isNonVisualStyleMutation({
          target: target,
          attributeName: attributeName,
          type: 'attributes'
        })) {
          return {
            type: 'mutation:attribute:non-visual-style',
            mutationData: {
              attributeName: attributeName,
              oldValue: oldValue,
              newValue: newValue
            }
          };
        }
        var isRLLPlaceholder = RLLPlaceholderHandlers.getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder) {
          return {
            type: 'mutation:rll-placeholder',
            mutationData: {
              attributeName: attributeName,
              oldValue: oldValue,
              newValue: newValue
            }
          };
        }
        var lastElementRect = _this.mapVisibleNodeRects.get(target);
        if (lastElementRect && isSameRectSize(rect, lastElementRect)) {
          return {
            type: 'mutation:attribute:no-layout-shift',
            mutationData: {
              attributeName: attributeName,
              oldValue: oldValue,
              newValue: newValue
            }
          };
        }
        return {
          type: 'mutation:attribute',
          mutationData: {
            attributeName: attributeName,
            oldValue: oldValue,
            newValue: newValue
          }
        };
      });
    });
    _defineProperty(this, "handleLayoutShift", function (_ref8) {
      var time = _ref8.time,
        changedRects = _ref8.changedRects;
      var _iterator3 = _createForOfIteratorHelper(changedRects),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var changedRect = _step3.value;
          var target = changedRect.node;
          if (target) {
            if (fg('platform_ufo_vc_next_filter_ls_entries_same_rect')) {
              var isSameCurrentAndPreviousRects = isSameRectDimensions(changedRect.rect, changedRect.previousRect);
              _this.onChange({
                time: time,
                elementRef: new WeakRef(target),
                visible: true,
                rect: changedRect.rect,
                previousRect: changedRect.previousRect,
                type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
              });
            } else {
              _this.onChange({
                time: time,
                elementRef: new WeakRef(target),
                visible: true,
                rect: changedRect.rect,
                previousRect: changedRect.previousRect,
                type: 'layout-shift'
              });
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
    this.mapVisibleNodeRects = new WeakMap();
    this.mapIs3pResult = new WeakMap();
    this.onChange = onChange;
    this.isStarted = false;
    this.intersectionObserver = null;
    this.mutationObserver = null;
    this.performanceObserver = null;

    // Initialize SSR context functions
    this.getSSRState = getSSRState;
    this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
  }
  return _createClass(ViewportObserver, [{
    key: "initializeObservers",
    value: function initializeObservers() {
      if (this.isStarted) {
        return;
      }
      this.intersectionObserver = createIntersectionObserver({
        onEntry: this.handleIntersectionEntry
      });
      this.mutationObserver = createMutationObserver({
        onChildListMutation: this.handleChildListMutation,
        onAttributeMutation: this.handleAttributeMutation
      });
      this.performanceObserver = createPerformanceObserver({
        onLayoutShift: this.handleLayoutShift
      });
    }
  }, {
    key: "start",
    value: function start() {
      var _this$mutationObserve, _this$performanceObse;
      if (this.isStarted) {
        return;
      }
      this.initializeObservers();
      (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
        attributeOldValue: true,
        attributes: true,
        childList: true,
        subtree: true
      });
      (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
        type: 'layout-shift',
        buffered: true,
        // @ts-ignore -error
        durationThreshold: 30
      });
      this.isStarted = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$mutationObserve2, _this$intersectionObs1, _this$performanceObse2;
      if (!this.isStarted) {
        return;
      }
      (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
      (_this$intersectionObs1 = this.intersectionObserver) === null || _this$intersectionObs1 === void 0 || _this$intersectionObs1.disconnect();
      (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
      this.isStarted = false;
      // Clean up caches when stopping
      cleanupCaches(this.mapIs3pResult);
    }
  }]);
}();
export { ViewportObserver as default };